import dayjs from 'dayjs'
import React from 'react'
import { Link } from 'react-router-dom'

function PrivacyTerms() {
   return (
      <div className="privacy-terms-section">
         <p>©{dayjs().year()} Atenya Intelligence Inc. All rights reserved.</p>
         <div className="d-flex align-items-center gap-4">
            <Link to={'/privacy-policy'} target="_blank" rel="noopener noreferrer">
               Privacy Policy
            </Link>
            <Link to={'/terms-condition'} target="_blank" rel="noopener noreferrer">
               Terms of Use
            </Link>
         </div>
      </div>
   )
}

export default PrivacyTerms
